import Image from '@/components/atoms/image copy';
import Link from '@/components/atoms/link';
import React from 'react';

export const HomeProductsSection = ({ data }: any) => {
 

  return (
    <div className="w-full bg-white px-4 py-6 lg:px-10">
<div className="mt-4 grid grid-cols-2 gap-4 sm:grid-cols-4 md:grid-cols-5 lg:mt-0 lg:grid-cols-6 xl:grid-cols-7">
        {data?.data?.dataSource?.card_header_button_section?.map((product: any, index: number) => {
          const isValueSection = product.card_title === "Valves and Fitings";
          return (
            <Link
              key={product.card_title || index}
              link={product.ctas[0].button.href}
              className="flex h-[150px] w-full cursor-pointer flex-col items-center gap-[16px] rounded-[12px] bg-[#E5E9EB] py-[20px] transition-all duration-300 hover:bg-[#E5E9EB] lg:bg-white lg:px-[24px]"
            >
              <div className={`${isValueSection?'h-[56px] mt-2.5':'h-[65px]' }`}>
                <Image
                  src={product.image.url}
                  alt={product.image.title}
                  width={54}
                  height={65}
                  className={`${isValueSection?'h-[56px] !w-[79px]':'h-[65px] !w-[54px]' }`}
                />
              </div>

              <h1 className="min-h-[48px] text-center text-[16px] font-medium leading-snug text-[#090909]">
                {product.card_title === 'Leak SmartShield' ? (
                  <>
                    Leak SmartShield<sup className="text-[12px] align-super">®</sup>
                  </>
                ) : (
                  product.card_title
                )}
              </h1>
            </Link>
          );
        })}
      </div>
    </div>
  );
};
